import React from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import type { Faq } from '../types/site';
interface FaqItemProps {
  faq: Faq;
  id: string;
  open: boolean;
  onToggle: () => void;
}
export function FaqItem({
  faq,
  id,
  open,
  onToggle
}: FaqItemProps) {
  const reduce = useReducedMotion();
  const buttonId = `${id}-button`;
  const panelId = `${id}-panel`;
  return <div className="border-b border-line" data-id="element-55" data-mp="1czsc1zaqw0xi">
      <h3 data-id="element-56" data-mp="1h2fbal9qwo4q">
        <button id={buttonId} type="button" aria-expanded={open} aria-controls={panelId} onClick={onToggle} className="flex min-h-[64px] w-full items-center justify-between gap-6 py-5 text-left text-[18px] font-semibold text-ink transition-colors duration-150 ease-out hover:text-brand-deep md:text-[20px]" data-id="element-57" data-mp="1h36vz11t11g8">
          {faq.question}
          <PlusIcon aria-hidden="true" className={`h-5 w-5 shrink-0 transition-transform duration-200 ease-out ${open ? 'rotate-45 text-brand' : ''}`} data-id="element-58" data-mp="32g9wnk9lkb5n" />
        </button>
      </h3>
      <AnimatePresence initial={false} data-id="element-59" data-mp="v28h22itoxh9">
        {open && <motion.div id={panelId} role="region" aria-labelledby={buttonId} initial={{
        height: reduce ? 'auto' : 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: reduce ? 'auto' : 0,
        opacity: 0
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden" data-id="element-60" data-mp="18ug8derc7w8k">
            <p className="max-w-[44rem] pb-7 pr-10 text-[16px] leading-relaxed text-steel md:text-[17px]" data-id="element-61" data-mp="q4q5s5hc2663">{faq.answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}